import * as React from 'react';

type MailProps = {
  width?: number;
  height?: number;
};

// tslint:disable:max-line-length
export const Mail = (props: MailProps) => (
  <svg width={props.width || 13} height={props.height || 9} viewBox='0 0 13 9' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M11.589925 0H1.410075C.632605 0 0 .632604 0 1.410075V7.13097c0 .777472.632604 1.410076 1.410075 1.410076h10.17985C12.367395 8.541046 13 7.908442 13 7.13097V1.410076C13 .632455 12.367396 0 11.589925 0zM1.410075.742145h10.17985c.368252 0 .66793.299678.66793.66793v.70192L7.29083 5.578405c-.10865.079558-.459833.28617-.775542.28617-.438162 0-.739324-.242235-.73977-.242532L.742145 2.15326v-.743185c0-.3684.299678-.66793.66793-.66793zm10.17985 7.056608H1.410075c-.368252 0-.66793-.299678-.66793-.66793v-4.07675l4.570127 3.147733c.101377.081042.547257.404914 1.203016.404914.618355 0 1.157746-.387696 1.208212-.425397l4.534355-3.164356V7.13112c0 .368104-.299678.667633-.66793.667633z'
      fill='#FFF'
    />
  </svg>
);



// WEBPACK FOOTER //
// src/app/src/components/Icons/Mail.tsx